"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Style = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _reactSelectAsyncPaginate = require("react-select-async-paginate");
var _MultiSelectInput = _interopRequireWildcard(require("./MultiSelectInput"));
var _react = _interopRequireDefault(require("react"));
var _excluded = ["ref", "components"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/*:: import { type ComponentType, type ElementRef } from 'react';*/
/*:: type Props = {
  components: ComponentType<*>,
  ref: ElementRef<*>
};*/
var Style = exports.Style = {
  loadingIndicator: function loadingIndicator() {
    return {
      display: 'none'
    };
  }
};
var AsyncPaginateWrapper = (0, _reactSelectAsyncPaginate.withAsyncPaginate)(_MultiSelectInput.default);
var AsyncPaginate = function AsyncPaginate(_ref /*:: */) {
  var ref = _ref /*:: */.ref,
    components = _ref /*:: */.components,
    props = (0, _objectWithoutProperties2.default)(_ref /*:: */, _excluded);
  if (components === null || components === void 0 ? void 0 : components.MenuList) {
    var MenuList = (0, _reactSelectAsyncPaginate.wrapMenuList)(components.MenuList);
    // Indicator still used for wrapped Menu List select components
    return /*#__PURE__*/_react.default.createElement(AsyncPaginateWrapper, (0, _extends2.default)({
      selectRef: ref,
      components: {
        MenuList: MenuList,
        MultiValueLabel: _MultiSelectInput.MultiValueLabel,
        Option: _MultiSelectInput.Option,
        SingleValue: _MultiSelectInput.SingleValue
      }
    }, props));
  } else {
    return /*#__PURE__*/_react.default.createElement(AsyncPaginateWrapper, (0, _extends2.default)({
      styles: Style,
      selectRef: ref,
      components: {
        MultiValueLabel: _MultiSelectInput.MultiValueLabel,
        Option: _MultiSelectInput.Option,
        SingleValue: _MultiSelectInput.SingleValue
      }
    }, props));
  }
};
var _default = exports.default = AsyncPaginate;
//# sourceMappingURL=AsyncPaginate.js.map